/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import More from './More/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Ledger/New/Payors/Content/Payors/Payor/Content/Content/Profile/PersonPaymentAccount/Content/Locations/Content"
  
}) {
let locations0NameValueData = fromData.useDataValue({ viewPath,
context: 'locations',
path: '[0].name',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 color={dtColorsNeutral600}
 data="locations.[0].name"
 text={locations0NameValueData}
/>
<More
  viewPath={`${viewPath}/More`}
/>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--w-1-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--h-2-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--bc-3-Z1Yf8zk': dtColorsNeutral300}}
 className={`views-block ${styles.Horizontal}`}
/>
{children}
</React.Fragment>)
}